/* hero-bg — random starting background-position, slow drift animation.
   Picks a random origin point on each load and sets it as a CSS custom
   property the keyframes animate away from. Respects reduced-motion. */

const prefersReducedMotion =
	window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

/* Background is sized at 160%, so 60% of slack exists per axis. The keyframe
   drifts +40% from the start, leaving a 20% window for the random origin so
   start + drift never runs past the image edge (which would show the navy
   background-color underneath). */
const SEED_MAX = 20;

function seedHeroBg( el ) {
	const x = Math.round( Math.random() * SEED_MAX );
	const y = Math.round( Math.random() * SEED_MAX );

	el.style.setProperty( '--hero-bg-x', `${ x }%` );
	el.style.setProperty( '--hero-bg-y', `${ y }%` );

	if ( ! prefersReducedMotion ) {
		el.classList.add( 'hero-bg--animate' );
	}
}

document.querySelectorAll( '.hero-bg' ).forEach( seedHeroBg );
